import { useEffect, useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import authApiService from "../../services/auth-api.service";

import Header from "../../components/header/Header";
import SideMenu from "./sidemenu/SideMenu";
import SystemSetting from "./systemsetting/SystemSetting";
import User from "./user/User";
import Role from "./role/Role";
import VehicleClass from "./vehicleclass/VehicleClass";
import Announcement from "./announcement/Announcement";
import RequestClass from "./requestclass/RequestClass";
import ScreenMessage from "./screenmessage/ScreenMessage";
import BaseStop from "./basestop/BaseStop";
import "./MasterLayout.scss";

const MasterLayout = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [baseName, setBaseName] = useState("");
  const [baseId, setBaseId] = useState<number | null>(null);

  useEffect(() => {
    const fetchMe = async () => {
      try {
        const user = await authApiService.me();

        if (user.role_cd !== "05") {
          navigate("/login");
          return;
        }

        setUserName(user.user_name);
        setBaseName(user.base_name);
        setBaseId(user.base_id);
      } catch (error) {
        navigate("/login");
      }
    };

    fetchMe();
  }, [navigate]);

  return (
    <div className="masterScreen">
      <Header userName={userName} baseName={baseName} />
      <div className="masterLayout">
        <SideMenu />
        <div className="masterContent">
          <Routes>
            <Route path="/" element={<Navigate to="systemsetting" replace />} />
            <Route
              path="systemsetting"
              element={<SystemSetting baseId={baseId} />}
            />
            <Route path="user" element={<User />} />
            <Route path="role" element={<Role />} />
            <Route
              path="vehicleclass"
              element={<VehicleClass baseId={baseId} />}
            />
            <Route
              path="announcement"
              element={<Announcement baseId={baseId} />}
            />
            <Route
              path="requestclass"
              element={<RequestClass baseId={baseId} />}
            />
            <Route path="screenmessage" element={<ScreenMessage />} />
            <Route path="basestop" element={<BaseStop baseId={baseId} />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default MasterLayout;
